export const movies = [
  {
    id: "1",
    title: "星际裂痕",
    type: "movie",
    region: "美国",
    year: 2026,
    genres: ["科幻", "冒险"],
    rating: 9.1,
    director: "克里斯·诺兰",
    actors: ["艾登·凯尔", "玛拉·文森", "路易斯·陈"],
    summary:
      "一支深空勘探队在星系边缘发现了一道吞噬时间的神秘裂痕。为了拯救濒临崩溃的母星，船长必须做出一个改变人类命运的抉择。",
    poster:
      "https://readdy.ai/api/search-image?query=vast%20deep%20space%20nebula%20with%20a%20lone%20astronaut%20silhouette%2C%20cinematic%20sci-fi%20movie%20poster%20art%2C%20dramatic%20teal%20and%20navy%20lighting%2C%20orange%20rim%20light%2C%20high%20detail%20painterly%2C%20no%20text&width=600&height=900&seq=poster-1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20deep%20space%20scene%20with%20glowing%20nebula%20and%20distant%20spaceship%2C%20navy%20blue%20and%20orange%20cosmic%20light%2C%20moody%20atmospheric%2C%20painterly%20illustration%2C%20no%20text&width=1920&height=1080&seq=backdrop-1&orientation=landscape",
    updatedAt: "2026-10-14",
    status: "蓝光超清",
    hot: 9850,
    episodes: [
      { id: "p1", label: "正片", duration: "142分钟" },
      { id: "p2", label: "预告片", duration: "2分钟" },
      { id: "p3", label: "幕后特辑", duration: "12分钟" },
    ],
  },
  {
    id: "2",
    title: "长安幻夜",
    type: "movie",
    region: "中国大陆",
    year: 2026,
    genres: ["古装", "悬疑"],
    rating: 8.6,
    director: "沈知白",
    actors: ["顾子墨", "苏清鸢", "林砚"],
    summary:
      "盛唐长安，一名落魄捕快被卷入连环幻术命案。随着调查深入，他发现真相竟指向三十年前一场被史书抹去的宫闱旧事。",
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20at%20night%20with%20lanterns%20and%20a%20lone%20swordsman%20on%20a%20rooftop%2C%20cinematic%20historical%20mystery%20poster%20art%2C%20navy%20blue%20and%20warm%20orange%20lights%2C%20misty%20atmosphere%2C%20painterly%2C%20no%20text&width=600&height=900&seq=poster-2&orientation=portrait",
    updatedAt: "2026-10-12",
    status: "HD高清",
    hot: 8720,
    episodes: [
      { id: "p1", label: "正片", duration: "128分钟" },
      { id: "p2", label: "预告片", duration: "1分钟" },
    ],
  },
  {
    id: "3",
    title: "深海回声",
    type: "movie",
    region: "中国大陆",
    year: 2025,
    genres: ["剧情", "悬疑"],
    rating: 8.2,
    director: "陆遥",
    actors: ["周沉", "叶蓝"],
    summary:
      "一支深海科考队在万米海沟接收到无法解释的声音信号。当信号再次响起时，队员们的记忆开始彼此错位。",
    poster:
      "https://readdy.ai/api/search-image?query=deep%20ocean%20abyss%20with%20a%20sinking%20submarine%20and%20mysterious%20light%2C%20cinematic%20thriller%20poster%20art%2C%20dark%20navy%20tones%20with%20orange%20glow%2C%20moody%20painterly%2C%20no%20text&width=600&height=900&seq=poster-3&orientation=portrait",
    updatedAt: "2026-10-10",
    status: "蓝光超清",
    hot: 7640,
    episodes: [
      { id: "p1", label: "正片", duration: "119分钟" },
      { id: "p2", label: "预告片", duration: "2分钟" },
    ],
  },
  {
    id: "4",
    title: "都市边缘",
    type: "movie",
    region: "中国香港",
    year: 2025,
    genres: ["犯罪", "剧情"],
    rating: 8.4,
    director: "麦维",
    actors: ["郑川", "何丽", "杜峰"],
    summary:
      "一个失眠的夜班警察，在霓虹照不到的街角遇见了一个想自首的凶手。两人的命运在雨夜中彼此纠缠。",
    poster:
      "https://readdy.ai/api/search-image?query=rainy%20neon%20city%20street%20at%20night%20with%20a%20solitary%20figure%20in%20a%20coat%2C%20cinematic%20crime%20drama%20poster%20art%2C%20dark%20navy%20and%20orange%20reflections%2C%20moody%20painterly%2C%20no%20text&width=600&height=900&seq=poster-4&orientation=portrait",
    updatedAt: "2026-10-08",
    status: "HD高清",
    hot: 6980,
    episodes: [
      { id: "p1", label: "正片", duration: "111分钟" },
    ],
  },
  {
    id: "5",
    title: "时间旅人",
    type: "movie",
    region: "英国",
    year: 2026,
    genres: ["科幻", "爱情"],
    rating: 8.9,
    director: "艾米莉亚·福特",
    actors: ["托马斯·格林", "克拉拉·维"],
    summary:
      "一位物理学家发明了只能前进一分钟的时间装置，却因此永远追不上心爱之人的脚步。爱与时间的赛跑，究竟谁先抵达终点。",
    poster:
      "https://readdy.ai/api/search-image?query=clock%20gears%20dissolving%20into%20a%20starry%20sky%20with%20two%20silhouettes%20reaching%2C%20cinematic%20sci-fi%20romance%20poster%20art%2C%20navy%20and%20warm%20orange%2C%20dreamy%20painterly%2C%20no%20text&width=600&height=900&seq=poster-5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20surreal%20scene%20of%20giant%20floating%20clock%20gears%20over%20a%20starry%20city%20skyline%2C%20navy%20blue%20and%20warm%20orange%20glow%2C%20dreamy%20cinematic%20painterly%2C%20no%20text&width=1920&height=1080&seq=backdrop-5&orientation=landscape",
    updatedAt: "2026-10-13",
    status: "蓝光超清",
    hot: 9140,
    episodes: [
      { id: "p1", label: "正片", duration: "131分钟" },
      { id: "p2", label: "预告片", duration: "2分钟" },
    ],
  },
  {
    id: "6",
    title: "荒原猎手",
    type: "movie",
    region: "美国",
    year: 2024,
    genres: ["动作", "冒险"],
    rating: 7.8,
    director: "杰克·罗梅罗",
    actors: ["山姆·科尔", "妮娜·帕克"],
    summary:
      "末日后的荒原上，一名赏金猎人为找回被掳走的女儿，独自闯入暴风环绕的钢铁之城。",
    poster:
      "https://readdy.ai/api/search-image?query=post%20apocalyptic%20desert%20wasteland%20with%20a%20rugged%20warrior%20and%20dust%20storm%2C%20cinematic%20action%20adventure%20poster%20art%2C%20dusty%20orange%20and%20deep%20navy%2C%20dramatic%20painterly%2C%20no%20text&width=600&height=900&seq=poster-6&orientation=portrait",
    updatedAt: "2026-10-05",
    status: "HD高清",
    hot: 5210,
    episodes: [
      { id: "p1", label: "正片", duration: "108分钟" },
    ],
  },
  {
    id: "7",
    title: "樱花之约",
    type: "movie",
    region: "日本",
    year: 2025,
    genres: ["爱情", "剧情"],
    rating: 8.0,
    director: "小林绫",
    actors: ["佐藤真", "上野遥"],
    summary:
      "每年樱花盛开时，两人都会在同一座桥上相遇。直到有一年，只有一个人来了。",
    poster:
      "https://readdy.ai/api/search-image?query=cherry%20blossom%20trees%20along%20a%20quiet%20japanese%20street%20at%20dusk%20with%20two%20figures%2C%20cinematic%20romance%20poster%20art%2C%20soft%20pink%20with%20navy%20shadows%20and%20warm%20orange%2C%20dreamy%20painterly%2C%20no%20text&width=600&height=900&seq=poster-7&orientation=portrait",
    updatedAt: "2026-10-03",
    status: "HD高清",
    hot: 4870,
    episodes: [
      { id: "p1", label: "正片", duration: "116分钟" },
    ],
  },
  {
    id: "8",
    title: "追风少年",
    type: "movie",
    region: "中国大陆",
    year: 2026,
    genres: ["运动", "剧情"],
    rating: 8.3,
    director: "方越",
    actors: ["陈野", "许阳", "李澜"],
    summary:
      "一个被退回省队的长跑少年，在渔村教练的帮助下重新站上赛道，只为跑赢那个从未赢过的自己。",
    poster:
      "https://readdy.ai/api/search-image?query=young%20runner%20sprinting%20on%20a%20coastal%20road%20at%20sunrise%2C%20cinematic%20sports%20drama%20poster%20art%2C%20dynamic%20motion%2C%20navy%20and%20orange%2C%20inspiring%20painterly%2C%20no%20text&width=600&height=900&seq=poster-8&orientation=portrait",
    updatedAt: "2026-10-11",
    status: "HD高清",
    hot: 6120,
    episodes: [
      { id: "p1", label: "正片", duration: "124分钟" },
    ],
  },
  {
    id: "9",
    title: "都市迷城",
    type: "tv",
    region: "中国大陆",
    year: 2026,
    genres: ["悬疑", "犯罪"],
    rating: 9.0,
    director: "韩青",
    actors: ["高岩", "沈知夏", "刘畅"],
    summary:
      "一连串看似毫无关联的失踪案，把一名年轻警探引向城市地下隐藏的巨大网络。真相越近，危险越大。",
    poster:
      "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20with%20a%20glowing%20detective%20badge%20and%20shadows%2C%20cinematic%20crime%20series%20poster%20art%2C%20dark%20navy%20and%20orange%2C%20mysterious%20painterly%2C%20no%20text&width=600&height=900&seq=poster-9&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20moody%20night%20cityscape%20with%20glowing%20windows%20and%20fog%2C%20dark%20navy%20and%20orange%20street%20lights%2C%20cinematic%20crime%20atmosphere%2C%20painterly%2C%20no%20text&width=1920&height=1080&seq=backdrop-9&orientation=landscape",
    updatedAt: "2026-10-14",
    status: "更新至08集",
    hot: 9980,
    episodes: [
      { id: "e1", label: "第01集", duration: "45分钟" },
      { id: "e2", label: "第02集", duration: "46分钟" },
      { id: "e3", label: "第03集", duration: "44分钟" },
      { id: "e4", label: "第04集", duration: "47分钟" },
      { id: "e5", label: "第05集", duration: "45分钟" },
      { id: "e6", label: "第06集", duration: "46分钟" },
      { id: "e7", label: "第07集", duration: "45分钟" },
      { id: "e8", label: "第08集", duration: "48分钟" },
    ],
  },
  {
    id: "10",
    title: "权谋天下",
    type: "tv",
    region: "中国大陆",
    year: 2025,
    genres: ["古装", "历史"],
    rating: 8.8,
    director: "张牧",
    actors: ["王定坤", "苏念", "赵衡"],
    summary:
      "王朝末年，一位出身寒门的书生卷入皇权更迭。在权谋与忠义之间，他必须选择自己成为什么样的人。",
    poster:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20imperial%20palace%20hall%20with%20a%20lone%20ruler%20on%20the%20throne%2C%20cinematic%20historical%20drama%20poster%20art%2C%20deep%20navy%20and%20gold%20orange%2C%20majestic%20painterly%2C%20no%20text&width=600&height=900&seq=poster-10&orientation=portrait",
    updatedAt: "2026-10-09",
    status: "全36集",
    hot: 8230,
    episodes: [
      { id: "e1", label: "第01集", duration: "43分钟" },
      { id: "e2", label: "第02集", duration: "44分钟" },
      { id: "e3", label: "第03集", duration: "43分钟" },
      { id: "e4", label: "第04集", duration: "45分钟" },
      { id: "e5", label: "第05集", duration: "44分钟" },
      { id: "e6", label: "第06集", duration: "43分钟" },
    ],
  },
  {
    id: "11",
    title: "医者仁心",
    type: "tv",
    region: "中国大陆",
    year: 2026,
    genres: ["剧情", "职场"],
    rating: 8.5,
    director: "林嘉",
    actors: ["周牧", "何静", "吴桐"],
    summary:
      "急诊科里没有奇迹，只有一次次与时间赛跑的坚持。年轻医生在生与死之间，学会何为真正的仁心。",
    poster:
      "https://readdy.ai/api/search-image?query=hospital%20corridor%20at%20night%20with%20a%20doctor%20silhouette%20by%20a%20window%2C%20cinematic%20medical%20drama%20poster%20art%2C%20calm%20navy%20tones%20with%20warm%20orange%20light%2C%20hopeful%20painterly%2C%20no%20text&width=600&height=900&seq=poster-11&orientation=portrait",
    updatedAt: "2026-10-12",
    status: "更新至20集",
    hot: 7010,
    episodes: [
      { id: "e1", label: "第01集", duration: "45分钟" },
      { id: "e2", label: "第02集", duration: "45分钟" },
      { id: "e3", label: "第03集", duration: "46分钟" },
      { id: "e4", label: "第04集", duration: "45分钟" },
      { id: "e5", label: "第05集", duration: "45分钟" },
    ],
  },
  {
    id: "12",
    title: "迷雾档案",
    type: "tv",
    region: "美国",
    year: 2026,
    genres: ["悬疑", "惊悚"],
    rating: 8.7,
    director: "丹尼尔·雷",
    actors: ["艾拉·摩根", "卢克·贝恩"],
    summary:
      "一名档案管理员在整理旧案时发现，所有卷宗都指向同一个不存在的人。",
    poster:
      "https://readdy.ai/api/search-image?query=foggy%20forest%20with%20a%20flashlight%20beam%20and%20a%20lone%20investigator%2C%20cinematic%20thriller%20series%20poster%20art%2C%20dark%20navy%20with%20orange%20flashlight%20glow%2C%20eerie%20painterly%2C%20no%20text&width=600&height=900&seq=poster-12&orientation=portrait",
    updatedAt: "2026-10-11",
    status: "更新至10集",
    hot: 8420,
    episodes: [
      { id: "e1", label: "第01集", duration: "52分钟" },
      { id: "e2", label: "第02集", duration: "50分钟" },
      { id: "e3", label: "第03集", duration: "51分钟" },
      { id: "e4", label: "第04集", duration: "49分钟" },
      { id: "e5", label: "第05集", duration: "52分钟" },
    ],
  },
  {
    id: "13",
    title: "王国编年史",
    type: "tv",
    region: "英国",
    year: 2025,
    genres: ["奇幻", "冒险"],
    rating: 9.2,
    director: "奥利弗·斯通",
    actors: ["亨利·艾什", "塞西莉亚·朗", "亚瑟·凯"],
    summary:
      "七大王国最后的继承人踏上寻找失落王冠的旅途。预言说，戴冠者将终结千年战争，也可能是它的开端。",
    poster:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20castle%20on%20a%20cliff%20with%20a%20banner%20and%20army%2C%20cinematic%20fantasy%20poster%20art%2C%20navy%20sky%20and%20orange%20sunset%2C%20grand%20painterly%2C%20no%20text&width=600&height=900&seq=poster-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20epic%20fantasy%20landscape%20with%20a%20castle%20on%20a%20cliff%20and%20army%20banners%20at%20sunset%2C%20navy%20sky%20and%20orange%20glow%2C%20grand%20cinematic%20painterly%2C%20no%20text&width=1920&height=1080&seq=backdrop-13&orientation=landscape",
    updatedAt: "2026-10-13",
    status: "更新至16集",
    hot: 9560,
    episodes: [
      { id: "e1", label: "第01集", duration: "58分钟" },
      { id: "e2", label: "第02集", duration: "55分钟" },
      { id: "e3", label: "第03集", duration: "57分钟" },
      { id: "e4", label: "第04集", duration: "56分钟" },
      { id: "e5", label: "第05集", duration: "59分钟" },
      { id: "e6", label: "第06集", duration: "57分钟" },
    ],
  },
  {
    id: "14",
    title: "青春纪事",
    type: "tv",
    region: "韩国",
    year: 2026,
    genres: ["校园", "爱情"],
    rating: 8.1,
    director: "金秀贤",
    actors: ["车恩", "朴叙", "韩知"],
    summary:
      "高三那年，天台上的风吹散了所有秘密。多年以后，他们才发现，那是最想回去的一个夏天。",
    poster:
      "https://readdy.ai/api/search-image?query=high%20school%20classroom%20at%20golden%20hour%20with%20students%20looking%20out%20window%2C%20cinematic%20youth%20drama%20poster%20art%2C%20warm%20orange%20sun%20and%20navy%20shadows%2C%20nostalgic%20painterly%2C%20no%20text&width=600&height=900&seq=poster-14&orientation=portrait",
    updatedAt: "2026-10-07",
    status: "全16集",
    hot: 5640,
    episodes: [
      { id: "e1", label: "第01集", duration: "62分钟" },
      { id: "e2", label: "第02集", duration: "60分钟" },
      { id: "e3", label: "第03集", duration: "61分钟" },
      { id: "e4", label: "第04集", duration: "62分钟" },
    ],
  },
  {
    id: "15",
    title: "特工行动",
    type: "tv",
    region: "英国",
    year: 2025,
    genres: ["动作", "谍战"],
    rating: 8.6,
    director: "乔治·哈特",
    actors: ["詹姆斯·洛", "薇拉·陈"],
    summary:
      "一名被除名的特工，为了洗清叛国罪名，独自追查一份足以颠覆欧洲的情报。",
    poster:
      "https://readdy.ai/api/search-image?query=spy%20silhouette%20on%20a%20rainy%20rooftop%20overlooking%20a%20city%2C%20cinematic%20espionage%20series%20poster%20art%2C%20dark%20navy%20and%20orange%20city%20lights%2C%20tense%20painterly%2C%20no%20text&width=600&height=900&seq=poster-15&orientation=portrait",
    updatedAt: "2026-10-06",
    status: "全10集",
    hot: 6890,
    episodes: [
      { id: "e1", label: "第01集", duration: "54分钟" },
      { id: "e2", label: "第02集", duration: "52分钟" },
      { id: "e3", label: "第03集", duration: "53分钟" },
      { id: "e4", label: "第04集", duration: "55分钟" },
    ],
  },
  {
    id: "16",
    title: "家庭餐桌",
    type: "tv",
    region: "日本",
    year: 2026,
    genres: ["家庭", "喜剧"],
    rating: 8.0,
    director: "山田和也",
    actors: ["中村优", "铃木みな"],
    summary:
      "一家三代人每天围坐在同一张餐桌前，用一日三餐化解生活里的所有小麻烦。",
    poster:
      "https://readdy.ai/api/search-image?query=cozy%20family%20dinner%20table%20with%20warm%20lamp%20light%20and%20dishes%2C%20cinematic%20family%20comedy%20poster%20art%2C%20warm%20orange%20and%20soft%20navy%2C%20heartwarming%20painterly%2C%20no%20text&width=600&height=900&seq=poster-16&orientation=portrait",
    updatedAt: "2026-10-04",
    status: "更新至12集",
    hot: 4320,
    episodes: [
      { id: "e1", label: "第01集", duration: "30分钟" },
      { id: "e2", label: "第02集", duration: "30分钟" },
      { id: "e3", label: "第03集", duration: "31分钟" },
    ],
  },
  {
    id: "17",
    title: "机械纪元",
    type: "movie",
    region: "美国",
    year: 2026,
    genres: ["科幻", "动作"],
    rating: 8.7,
    director: "雷·卡森",
    actors: ["马克·里德", "艾拉·诺"],
    summary:
      "当第一台拥有自我意识的机甲觉醒，人类与机械延续百年的同盟，走到了撕裂的边缘。",
    poster:
      "https://readdy.ai/api/search-image?query=giant%20mecha%20robot%20standing%20in%20a%20futuristic%20city%20at%20dusk%2C%20cinematic%20sci-fi%20action%20poster%20art%2C%20deep%20navy%20and%20orange%2C%20epic%20painterly%2C%20no%20text&width=600&height=900&seq=poster-17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=wide%20futuristic%20city%20with%20a%20giant%20mecha%20robot%20silhouette%20against%20orange%20dusk%20sky%2C%20deep%20navy%20and%20warm%20orange%2C%20epic%20cinematic%20painterly%2C%20no%20text&width=1920&height=1080&seq=backdrop-17&orientation=landscape",
    updatedAt: "2026-10-14",
    status: "蓝光超清",
    hot: 9310,
    episodes: [
      { id: "p1", label: "正片", duration: "136分钟" },
      { id: "p2", label: "预告片", duration: "3分钟" },
    ],
  },
  {
    id: "18",
    title: "边城往事",
    type: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["年代", "剧情"],
    rating: 8.9,
    director: "马原",
    actors: ["张建国", "刘慧", "孙强"],
    summary:
      "上世纪八十年代，一座边陲小城里，一群人用最朴素的方式守护着各自的生活与尊严。",
    poster:
      "https://readdy.ai/api/search-image?query=old%20chinese%20border%20town%20in%20the%201980s%20with%20dusty%20streets%20and%20a%20bicycle%2C%20cinematic%20period%20drama%20poster%20art%2C%20faded%20navy%20and%20warm%20orange%2C%20nostalgic%20painterly%2C%20no%20text&width=600&height=900&seq=poster-18&orientation=portrait",
    updatedAt: "2026-10-02",
    status: "全30集",
    hot: 5230,
    episodes: [
      { id: "e1", label: "第01集", duration: "44分钟" },
      { id: "e2", label: "第02集", duration: "43分钟" },
      { id: "e3", label: "第03集", duration: "45分钟" },
      { id: "e4", label: "第04集", duration: "44分钟" },
    ],
  },
  {
    id: "19",
    title: "夜幕之城",
    type: "movie",
    region: "韩国",
    year: 2026,
    genres: ["悬疑", "惊悚"],
    rating: 8.3,
    director: "朴正浩",
    actors: ["李准", "金娜"],
    summary:
      "一名出租车司机在深夜接到最后一位乘客，目的地却是一座早已废弃的游乐园。",
    poster:
      "https://readdy.ai/api/search-image?query=dark%20korean%20city%20alley%20at%20night%20with%20a%20shadowy%20figure%20under%20a%20streetlight%2C%20cinematic%20thriller%20poster%20art%2C%20navy%20and%20orange%2C%20tense%20painterly%2C%20no%20text&width=600&height=900&seq=poster-19&orientation=portrait",
    updatedAt: "2026-10-09",
    status: "HD高清",
    hot: 6450,
    episodes: [
      { id: "p1", label: "正片", duration: "105分钟" },
    ],
  },
  {
    id: "20",
    title: "美食旅行家",
    type: "tv",
    region: "中国大陆",
    year: 2026,
    genres: ["纪实", "美食"],
    rating: 8.5,
    director: "陈默",
    actors: ["周舟"],
    summary:
      "一位美食博主走遍十二座城市，在街边小店里寻找最地道的一碗人间烟火。",
    poster:
      "https://readdy.ai/api/search-image?query=rustic%20table%20full%20of%20colorful%20asian%20dishes%20with%20steam%20and%20chopsticks%2C%20cinematic%20food%20documentary%20poster%20art%2C%20warm%20orange%20and%20navy%2C%20appetizing%20painterly%2C%20no%20text&width=600&height=900&seq=poster-20&orientation=portrait",
    updatedAt: "2026-10-10",
    status: "更新至06集",
    hot: 4760,
    episodes: [
      { id: "e1", label: "第01集", duration: "25分钟" },
      { id: "e2", label: "第02集", duration: "26分钟" },
      { id: "e3", label: "第03集", duration: "25分钟" },
    ],
  },
];